/* lettra: Warenkorb-Vorschau — setzt Schrift und passt die Groesse ein.

   Farbe und Schatten kommen aus den Klassen .ink / .snow in lettra.css, die
   Schriftzuordnung aus window.LETTRA_FONTS. Hier steht deshalb weder ein
   Hex-Wert noch ein Schriftname.

   Gemessen wird erst nach document.fonts.ready: Vorher misst der Browser die
   Ersatzschrift, und die baut anders — dieselbe Falle wie beim Fit im Hero
   und im Konfigurator. */
(function () {
  'use strict';

  var RAND = 8; /* Luft links und rechts, laut Vorgabe */
  var MIN = 11; /* Untergrenze: darunter ist der Schriftzug kein Schriftzug mehr */
  var MAX = 34; /* Obergrenze: passt in die 92px hohe Box samt Zeilenhoehe 1.05 */

  /* Mess-Canvas mit calt und liga aus, wie die Vorschau selbst (lettra.css,
     .lettra-cart-preview__text): Die Bibliothek druckt nur Grundglyphen. Das
     Canvas muss dafuer im Dokument haengen — losgeloest ignoriert der
     Browser font-feature-settings (Chrome 148, 1. 9. 2026). Deshalb erst
     beim ersten Einpassen angelegt, wenn body sicher da ist. */
  var mess = null;
  function messKontext() {
    if (mess) return mess;
    try {
      var c = document.createElement('canvas');
      c.width = 1;
      c.height = 1;
      c.hidden = true;
      c.setAttribute('aria-hidden', 'true');
      c.style.fontFeatureSettings = '"calt" 0, "liga" 0';
      document.body.appendChild(c);
      mess = c.getContext('2d');
    } catch (e) {
      mess = null;
    }
    return mess;
  }

  function einpassen(kasten) {
    var span = kasten.querySelector('[data-lettra-cart-preview-text]');
    if (!span) return;

    var name = kasten.getAttribute('data-font');
    var f = window.lettraFontByName ? window.lettraFontByName(name) : null;
    if (f) {
      span.style.fontFamily = f.css;
      span.style.fontWeight = f.w;
    }

    var text = span.textContent.trim();
    if (!text) return;

    var breite = kasten.clientWidth - 2 * RAND;
    if (!(breite > 0)) return;

    var groesse = MAX;
    var ctx = messKontext();
    if (ctx) {
      /* Bei einer Referenzgroesse messen und einmal rechnen statt zu suchen:
         Die Textbreite skaliert linear mit der Schriftgroesse. */
      var REF = 100;
      ctx.font = (f ? f.w : 400) + ' ' + REF + 'px ' + (f ? f.css : 'sans-serif');
      var refBreite = ctx.measureText(text).width;
      if (refBreite > 0) groesse = Math.floor((breite / refBreite) * REF);
    }
    if (groesse > MAX) groesse = MAX;
    if (groesse < MIN) groesse = MIN;
    span.style.fontSize = groesse + 'px';

    /* Die Canvas-Rechnung ist nur der erste Griff. Massgeblich ist das
       gerenderte Element: Der Kasten kann zwischen Rechnung und Anzeige noch
       schmaler werden — im Drawer deckelt max-width ihn von 132 auf 100px,
       und wer den Zeitpunkt errät, raet falsch. scrollWidth gegen clientWidth
       fragt den Browser nach dem, was wirklich dasteht. Hoechstens MAX-MIN
       Schritte, jeder eine Layoutabfrage — bei einer Handvoll Kaesten
       unmerklich. */
    var schritte = 0;
    while (span.scrollWidth > span.clientWidth + 1 && groesse > MIN && schritte < MAX) {
      groesse -= 1;
      span.style.fontSize = groesse + 'px';
      schritte++;
    }

    /* Passt es auch bei MIN nicht mehr, wird gekuerzt statt ueberzulaufen.
       Ein abgeschnittener Schriftzug ohne Zeichen dafuer sieht aus wie ein
       Darstellungsfehler; mit Auslassungspunkten ist erkennbar, dass mehr
       dasteht — und die vollstaendige Angabe steht ohnehin als "Text:" in der
       Zeile daneben. */
    kasten.classList.toggle('is-gekuerzt', span.scrollWidth > span.clientWidth + 1);
    kasten.setAttribute('data-fertig', '1');

    /* Einmal im naechsten Frame nachfassen. Zwischen Rechnung und endgueltigem
       Layout kann sich die Breite noch aendern — genau daran ist die erste
       Fassung gescheitert. Der Wiedereintritt ist durch das Flag begrenzt, es
       gibt also hoechstens einen zweiten Durchlauf je Kasten und keine
       Schleife. */
    if (!kasten.__nachgefasst) {
      kasten.__nachgefasst = true;
      requestAnimationFrame(function () { einpassen(kasten); });
    }
  }

  function alle() {
    var kaesten = document.querySelectorAll('[data-lettra-cart-preview]');
    for (var i = 0; i < kaesten.length; i++) einpassen(kaesten[i]);
  }

  function starten() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(alle, alle);
    } else {
      alle();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  /* Zwei Faelle, in denen nachgerechnet werden muss:

     1. Der Drawer steht beim Laden im Dokument, ist aber verborgen — seine
        Kaesten sind dann 0px breit und lassen sich nicht einpassen. Erst beim
        Oeffnen bekommen sie eine Breite. Ohne das hier stuende dort die
        Startgroesse von 16px, und ein langer Schriftzug liefe ueber.
     2. Drawer und Warenkorbseite zeichnen ihre Zeilen nach jeder
        Mengenaenderung neu; die Kaesten sind dann neue Elemente.

     Ein ResizeObserver deckt beides ab und braucht keinen Dawn-Code: Er
     feuert, sobald ein Kasten zum ersten Mal eine Breite hat. */
  var groessenBeobachter = window.ResizeObserver
    ? new ResizeObserver(function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          var el = eintraege[i].target;
          if (el.clientWidth > 0) einpassen(el);
        }
      })
    : null;

  function beobachten() {
    if (!groessenBeobachter) return;
    var kaesten = document.querySelectorAll('[data-lettra-cart-preview]');
    for (var i = 0; i < kaesten.length; i++) groessenBeobachter.observe(kaesten[i]);
  }

  if (window.MutationObserver) {
    var warte = null;
    new MutationObserver(function () {
      clearTimeout(warte);
      warte = setTimeout(function () {
        var offen = document.querySelectorAll('[data-lettra-cart-preview]:not([data-fertig])');
        if (offen.length) { starten(); beobachten(); }
      }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  beobachten();
})();
